import React from 'react';

import { Group, NumberInput, Stack, Text } from '@mantine/core';

import { blockNonInteger, TimeResult } from './types';

interface TimeInputProps {
  value: TimeResult;
  onChange: (value: TimeResult) => void;
  enlarged?: boolean;
}

const TimeInput = ({ value, onChange, enlarged = false }: TimeInputProps): JSX.Element => (
  <Group spacing='xs' align='flex-end' noWrap>
    <Stack spacing={4} sx={{ flex: 1 }}>
      <Text size={enlarged ? 'lg' : 'xs'} weight={600} color='dimmed' transform='uppercase'>
        Min
      </Text>
      <NumberInput
        value={value.minutes}
        onChange={minutes => onChange({ ...value, minutes })}
        min={0}
        precision={0}
        inputMode='numeric'
        onKeyDown={blockNonInteger}
        size={enlarged ? 'xl' : 'md'}
      />
    </Stack>
    <Text pb={6} align='center' weight={700} size='xl' color='dimmed'>
      :
    </Text>
    <Stack spacing={4} sx={{ flex: 1 }}>
      <Text size={enlarged ? 'lg' : 'xs'} weight={600} color='dimmed' transform='uppercase'>
        Sec
      </Text>
      <NumberInput
        value={value.seconds}
        onChange={seconds => onChange({ ...value, seconds })}
        min={0}
        max={59}
        precision={0}
        inputMode='numeric'
        onKeyDown={blockNonInteger}
        size={enlarged ? 'xl' : 'md'}
      />
    </Stack>
  </Group>
);

export default TimeInput;
